<script>
export default {
  name: "GiftItem",
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    unit: {
      type: String,
      default: ""
    }
  },
  methods: {
    onClick() {
      this.$emit("click", this.item);
    }
  }
};
</script>

<template>
  <div class="gift-item flex flex-col justify-center items-center" @click="onClick">
    <img :src="item.img_url" alt="">
    <p class="text-sm">{{item.name}}</p>
    <p class="text-red-600 font-bold price">{{ item.coin_price }} {{unit}}</p>
  </div>
</template>

<style scoped>
.gift-item img {
  width: 60%;
  margin-bottom: 0.2rem;
}
.gift-item p {
  text-align: center;
}

.price {
  font-size: 0.6rem;
  line-height: 0.8rem;
}
</style>
